import _ from "lodash";
import TableReportHelper from "report/helper";

export default function ApontamentoPontosColetasReport(
    visita,
    indicador,
    apontamento,
    params,
    titulo,
    fieldValor,


) {

    if (_.isEmpty(apontamento.pontosColetas)) {
        return null;
    }

    for (let index = 0; index < apontamento.pontosColetas.length; index++) {
        let pontoAux = apontamento.pontosColetas[index]
        if (!pontoAux) {
            throw new Error("Visita com ponto de coleta em branco");
        } else if (pontoAux.coletas) {
            for (let i = 0; i < pontoAux.coletas.length; i++) {
                if (!pontoAux.coletas[i].valor) {
                    throw new Error("Visita com coleta em branco");
                }
            }
        } else if (!pontoAux.coletas) {
            throw new Error("Visita com ponto sem coleta");
        }
    }

    const h = new TableReportHelper(apontamento);

    const content = [
        h.panel([
            // prettier-ignore
            h.row(
                h.title("PONTOS DE COLETAS")
            ),
        ]),
    ];

    let pontosContent = [];
    for (let index = 0; index < apontamento.pontosColetas.length; index++) {
        pontosContent = [];
        const ponto = apontamento.pontosColetas[index];
        if (!ponto.coletas) {
            ponto.coletas = []
        }
        const r = h.helper(ponto);
        pontosContent.push(
            h.row(
                h.title("Ponto " + (index + 1) + " - " + titulo, { colSpan: 2 }),
                h.title("Conf. Ponto"),
            )
        );
        const valuesPonto = []

        if (ponto.coletas) {
            for (const coleta of ponto.coletas) {
                const r = h.helper(coleta);
                valuesPonto.push(
                    r.textField(fieldValor),
                );
            }
        }

        let ww = ponto.coletas.map(c => 20)

        pontosContent.push(

            h.row(
                h.panel([h.row(valuesPonto)], { widths: ww }),
                r.locationField("georeferencia"),
                r.textField("conformidade"),
            )
        );
        content.push(h.panel(pontosContent, { widths: ["*", 20, 60] }));
        if (ponto.images) {
            content.push(imagesReport(ponto))
        }

    }




    return content;
}

function imagesReport(ponto) {
    if (_.isEmpty(ponto.images)) {
        return null;
    }

    const h = new TableReportHelper(ponto);

    const content = [
        h.panel([
            // prettier-ignore
            h.row(
                h.title("Imagens do Ponto")
            ),
        ]),
    ];

    const imagesContent = [
        // prettier-ignore
        h.row(
            h.title("Foto"),
            h.title(""),
            h.title("Descrição"),
        ),
    ];

    for (const image of ponto.images) {
        const r = h.helper(image);

        imagesContent.push(
            // prettier-ignore
            h.row(
                r.imageField("base64", { fit: [150, 150], }),
                r.locationField("georeferencia"),
                r.textField("descricao"),
            )
        );
    }

    content.push(h.panel(imagesContent, { widths: [150, 40, "*"] }, { colSpan: 3 }));
    return content
}
